// 获取发行版本列表
export const GET_VERSION_LIST = 'GET_VERSION_LIST';

// 更新数据
export const RESEVRE_DELIVER_UPDATA = 'RESEVRE_DELIVER_UPDATA';

// 错误
export const RESEVRE_DELIVER_FILE = 'RESEVRE_DELIVER_FILE';

// 发布版本
export const VERSION_RELEASE = 'VERSION_RELEASE';
// 发布版本
export const OPEN_CODE_PUSH = 'OPEN_CODE_PUSH';
